import React from 'react';

import {
  forwardRef,
  Icon as ChakraIcon,
  useStyleConfig,
} from '@chakra-ui/react';

import { IconProps } from './types';

export const Icon = forwardRef<IconProps, 'svg'>((props, ref) => {
  const { size } = props;
  const sizeStyles = useStyleConfig('Icon', {
    size,
  });
  return <ChakraIcon ref={ref} {...props} __css={sizeStyles} />;
});
